import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { ROLE, TOKEN } from '../../../_helpers/token';
import { baseURL } from '../../../_helpers';
import axios from 'axios';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };
  componentDidMount() {
    axios.get(baseURL).then(res => { })

    if (TOKEN == null) {
      window.location.href = "/log_in";

    }
  }
  logout = () => {
    localStorage.removeItem('token');
  }
  render() {
    const { changeToLight, changeToDark } = this.props;

    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          <SidebarCategory title="Layout" icon="layers">
            <button className="sidebar__link" type="button" onClick={changeToLight}>
              <p className="sidebar__link-title">Light Theme</p>
            </button>
            <button className="sidebar__link" type="button" onClick={changeToDark}>
              <p className="sidebar__link-title">Dark Theme</p>
            </button>
          </SidebarCategory>
        </ul>
        <ul className="sidebar__block">

          {ROLE === '10' ?
            <>

              <SidebarLink
                title="Daily Customers"
                route="/customers"
                icon="users"
                onClick={this.hideSidebar}
              />

              <SidebarCategory title="Finance" icon="briefcase">

                <SidebarLink title="Daily Deposits" route="/dailydeposit" onClick={this.hideSidebar} />
                <SidebarLink title="Reversals" route="/reversals" onClick={this.hideSidebar} />
                <SidebarLink title="Daily Withdrawal" route="/customers-withdrawals" onClick={this.hideSidebar} />
               
                <SidebarLink title="Draw" route="/transaction" onClick={this.hideSidebar} />
                <SidebarLink title="Mpesa Reversal" route="/reverse" onClick={this.hideSidebar} />


              </SidebarCategory>

              <SidebarCategory title="Bets" icon="book">
                <SidebarLink title="Bets Per Day" route="/betsperday" onClick={this.hideSidebar} />
                <SidebarLink title="Average Bets" route="/averagebets" onClick={this.hideSidebar} />
              </SidebarCategory>


              <SidebarCategory title="Report" icon="book">
                <SidebarLink title="Daily Stake and Income" route="/summary" onClick={this.hideSidebar} />
                <SidebarLink title="Incoming Calls" route="/incoming_feed" onClick={this.hideSidebar} />
                <SidebarLink title="Outgoing Calls" route="/outgoing_feed" onClick={this.hideSidebar} />
         
                <SidebarLink title="NetCashFlow" route="/eod" onClick={this.hideSidebar} />
              </SidebarCategory>
              <SidebarCategory title="Mpesa Reconciliation" icon="briefcase">
                <SidebarLink title="Deposits" route="/reconciledeposits" onClick={this.hideSidebar} />
              </SidebarCategory>
              <SidebarLink
                title="User Search"
                icon="user"
                route="/user"
                onClick={this.hideSidebar}
              />
              <SidebarLink title="Blacklist" route="/blacklist" icon="users" onClick={this.hideSidebar} />
              <SidebarCategory title="Blasts" icon="phone">
                <SidebarLink title="Last Active Day" route="/blasts" onClick={this.hideSidebar} />
              
                <SidebarLink title="Active Depositors" route="/activeDepositors" onClick={this.hideSidebar} />
                <SidebarLink title="Count of Plays" route="/countplays" onClick={this.hideSidebar} />
                <SidebarLink title="Never Deposit" route="/never_deposited" onClick={this.hideSidebar} />

                
                <SidebarLink title="Wallet Balance" route="/balance_blast" onClick={this.hideSidebar} />
  
                <SidebarLink title="Blasted Messages" route="/blasted_messages" onClick={this.hideSidebar} />
              
              </SidebarCategory>
            </>
            : null}


          {ROLE === '11' ?
            <>
              <SidebarCategory title="Gaming Board Report" icon="briefcase">
                <SidebarLink
                  title="Daily Customers"
                  route="/customers"
                  onClick={this.hideSidebar}
                />
                <SidebarLink title="Daily Deposits" route="/gnetcashflow" onClick={this.hideSidebar} />
                <SidebarLink title="Daily Winnings" route="/customers-withdrawals" onClick={this.hideSidebar} />
                <SidebarLink title="NetCashFlow" route="/netcashflow" onClick={this.hideSidebar} />

              </SidebarCategory>
            </>
            : null}
          {ROLE === '12' ?
            <>
              <SidebarCategory title="Bets" icon="book">
                <SidebarLink title="Bets Per Day" route="/betsperday" onClick={this.hideSidebar} />
                <SidebarLink title="Average Bets" route="/averagebets" onClick={this.hideSidebar} />
              </SidebarCategory>


              <SidebarLink
                title="User Search"
                icon="user"
                route="/user"
                onClick={this.hideSidebar}
              />
              <SidebarLink title="Blacklist" route="/blacklist" icon="users" onClick={this.hideSidebar} />
            </>
            : null}
        </ul>
        <ul className="sidebar__block">
          <SidebarLink
            title="LogOut"
            route="/log_in"
            onClick={this.logout}
            icon="user"
          />
        </ul>

      </div>
    );
  }
}

export default SidebarContent;
